/**
 * useProfileSyncing — React hook exposing global profile sync progress.
 */

import { useState, useEffect } from "react";
import { getSyncProgress, onSyncChange, type SyncProgress } from "@/lib/profileSyncState";

export function useProfileSyncing(): SyncProgress {
  const [state, setState] = useState<SyncProgress>(getSyncProgress);

  useEffect(() => {
    setState(getSyncProgress());
    return onSyncChange(setState);
  }, []);

  return state;
}
